import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';



@Component({
  selector: 'modal-filter-select',
  templateUrl: './modal-filter-select.component.html',
  styleUrls: ['./modal-filter-select.component.scss'],
})
export class ModalFilterSelectComponent implements OnInit {

  choices: any;
  selected: any;


  constructor(public appearanceService: AppearanceService,
   public userService: UserService, public modalController: ModalController) {

  }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {
    
  }


  clearSelected()
  {
    var returnData = { searchFor: 'clear' };
    this.modalController.dismiss(returnData, null, 'FilterSelectModal');
  }


  saveSelected(selected)
  {
    var returnData = { searchFor: selected };
    this.modalController.dismiss(returnData, null, 'FilterSelectModal');
  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'FilterSelectModal');
  }
}
